import React, { useState } from 'react';
import { PaginationControl } from 'components/molecules/paginationControl';
import HorizontalCarousel from 'components/templates/horizontalCarouselModule';
import { useViewport } from 'components/templates/viewportProvider';
import styles from './styles.scss';

const VisionPhilosophy = props => {
  const { height } = useViewport();
  const [count, setCount] = useState(1);
  const [previousImage, setPreviousImage] = useState(null);
  const [image, setImage] = useState(null);

  const { type } = props;
  const { showButton, showCount } = props.data;
  const { visionSection, mediaPath } = props.data.visionPhilosophySection;
  const paginationValues = Object.keys(visionSection);

  const next = () => {
    setPreviousImage(`${mediaPath.web}/${visionSection[count].image_web}`);
    if (count < paginationValues.length) {
      setCount(count + 1);
      setImage(`${mediaPath.web}/${visionSection[count + 1].image_web}`);
    } else {
      setCount(1);
      setImage(`${mediaPath.web}/${visionSection[1].image_web}`);
    }
  };

  const previous = () => {
    setPreviousImage(`${mediaPath.web}/${visionSection[count].image_web}`);
    if (count > paginationValues[0]) {
      setCount(count - 1);
      setImage(`${mediaPath.web}/${visionSection[count - 1].image_web}`);
    } else if (count === 1) {
      setCount(paginationValues.length);
      setImage(
        `${mediaPath.web}/${visionSection[paginationValues.length].image_web}`
      );
    }
  };

  const imageUrl = `${mediaPath.web}/${visionSection[count].image_web}`;

  if (Object.keys(visionSection).length === 0) {
    return null;
  }

  return (
    <div
      className={
        type === 'restaurant'
          ? 'horizontal-module'
          : 'horizontal-module section-container'
      }
      style={{ height }}
    >
      <div className={'section-content'}>
        <HorizontalCarousel
          displayCard={false}
          displayCount={showCount}
          result={visionSection}
          count={count}
          previous={previous}
          next={next}
          pageValue={paginationValues}
          image={image || imageUrl}
          previousImage={previousImage}
          type={type}
        />
      </div>
      <div
        className={
          type === 'restaurant' ? 'section-footer paginate' : 'section-footer'
        }
      >
        <PaginationControl
          className={'pagination-button'}
          theme={'light-theme'}
          onPreviousClick={previous}
          onNextClick={next}
          currentIndex={count}
          total={paginationValues.length}
        />
      </div>
    </div>
  );
};

export default VisionPhilosophy;
